export const camelToFlatCase = (value?: string) => {
  if (!value) {
    return '';
  }

  return (value = value.replace(/[A-Z]/g, ' $&')), value[0].toUpperCase() + value.slice(1);
};
